import { SET_NO_DEFAULT } from "../../actions/action.types";

const noDefault = (state = false, action: any) => {
  if (action.type === SET_NO_DEFAULT) return action.payload;
  return state;
};

export default noDefault;
